// extracted by mini-css-extract-plugin
export default {"scoreContainer":"score_panel_scoreContainer__1TGaG"};